import React from 'react';
const IconRatingThumbsUp = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 7H15V4C15 3.46957 14.7893 2.96086 14.4142 2.58579C14.0391 2.21071 13.5304 2 13 2H11.57L6 8.64V16H8V9.36L12.5 4H13V9H19C19.2652 9 19.5196 9.10536 19.7071 9.29289C19.8946 9.48043 20 9.73478 20 10V12.68L15.53 18H6V20H16.47L22 13.4V10C22 9.20435 21.6839 8.44129 21.1213 7.87868C20.5587 7.31607 19.7956 7 19 7ZM2 20H4V9H2V20Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconRatingThumbsUp;